var TimelineMax = TimelineMax || {};
var TweenMax = TweenMax || {};
var platformCheck = platformCheck || {};
var site = site || {};

(function ($) {
  'use strict';

  Drupal.behaviors.boutiqueAerinSideNavV2 = {
    attach: function (context) {
      // DOM
      var $window = $(window);
      var $sideNav = $('.js-boutique-aerin-side-nav-v2', context); // Expected to be only one on the page
      var $sideNavContent = $sideNav.find('.aerin_nav-wrapper', context);
      // LOGIC
      var animationPlaying = false;
      var animation = new TimelineMax({ paused: true });
      var platformVars = platformCheck({
        target: $sideNav[0],
        mobileSize: 767,
        isMobileCallback: function () {
          return typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
        }
      });
      var isDropdown = $sideNav.hasClass('dropdown');

      // BEGIN: Init
      // Set up side nav mobile / Portrait / dropdown
      if (platformVars.isMobile || platformVars.orientation || isDropdown) {
        animation
          .to($sideNavContent.find('.nav-group-container').not('#section-footer'), 0.5, { y: '0%' })
          .to($sideNavContent.find('.shop-arrow-container'), 0.5, { rotation: '90deg' }, '0')
          .set($sideNavContent, { className: '+=active' })
          .addPause()
          .addLabel('exit', '+=0.1')
          .to($sideNavContent.find('.nav-group-container').not('#section-footer'), 0.5, { y: '-125%' })
          .to($sideNavContent.find('.shop-arrow-container'), 0.5, { rotation: '0deg' }, '-=0.5')
          .set($sideNavContent, { className: '-=active' });
      } else {
        animation
          .staggerFrom($sideNavContent.find('.nav_logo, dd, dt'), 0.5, {
            opacity: 0,
            x: '-=20%'
          }, 0.1);
      }

      // Mark <a> links in side nav that match current page label
      $sideNavContent.find('.nav-group a').each(function () {
        // DOM
        var $this = $(this);

        if ($this[0].pathname === location.pathname) {
          $this.addClass('active');
        }
      });

      // Play side nav intro after a set time
      $window.load(function () {
        setTimeout(function () {
          if (animationPlaying) {
            return;
          }

          $window.trigger('playSideNavAnimation');
        }, 3000);
      });

      // Since we're not using preloader, immediately attempt to load images
      $sideNav.find('img').each(function () {
        // DOM
        var $this = $(this);
        // LOGIC
        var src = $this.attr('data-src');

        // data-src must be defined and not an empty string
        if (typeof src !== 'undefined' && src.trim().length !== 0) {
          $this.attr('src', src);
        }
      });

      // END: Init

      // BEGIN: Events
      $window
        .on('platformcheck-update', function (e) {
          // DOM
          var $animationTargets = $sideNavContent.find('.nav_logo, dd, dt, .nav-group-container, .shop-arrow-container');
          // LOGIC
          var flag = e.originalEvent.detail.flag;

          // Sets portrait class based on orientation
          function toggleOrientation() {
            if (platformVars.orientation) {
              $sideNav.addClass('js-ipad-portrait');
            } else if (platformVars.orientation === false) {
              $sideNav.removeClass('js-ipad-portrait');
            }
          }

          // Build mobile animation whenever orientation is portrait
          function handlePortrait() {
            if (platformVars.orientation || platformVars.isMobile || isDropdown) {
              animation = new TimelineMax({ paused: true });

              animation
                .to($sideNavContent.find('.nav-group-container').not('#section-footer'), 0.5, { y: '0%' })
                .to($sideNavContent.find('.shop-arrow-container'), 0.5, { rotation: '90deg' }, '0')
                .set($sideNavContent, { className: '+=active' })
                .addPause()
                .addLabel('exit', '+=0.1')
                .to($sideNavContent.find('.nav-group-container').not('#section-footer'), 0.5, { y: '-125%' })
                .to($sideNavContent.find('.shop-arrow-container'), 0.5, { rotation: '0deg' }, '-=0.5')
                .set($sideNavContent, { className: '-=active' });

              animation.progress(0);
            }
          }

          // Update platform vars
          platformVars = e.originalEvent.detail.platformVars;

          // Desktop mobile width detection
          if (platformVars.isDesktop && (flag & platformCheck.FLAG_MOBILE)) {
            $sideNav.toggleClass('mobile');
          }

          if (platformVars.isIpad && (flag & platformCheck.FLAG_ORIENTATION)) {
            toggleOrientation();
          }

          // If changes happened flag will not be 0
          // iPad needs to listen for orientation changes
          // Rebuild animation whenever the orientation / desktop-mobile changes
          if (flag !== 0) {
            $sideNavContent.find('*').removeAttr('style');

            // Stop all animation
            TweenMax.killTweensOf($sideNavContent.add($animationTargets));

            // Clear existing styles and classes
            $sideNavContent.add($animationTargets).removeAttr('style');
            $sideNavContent.removeClass('active');

            handlePortrait();
          }
        })
        .one('loadAnimationComplete playSideNavAnimation', function () {
          // Determines whether to play animation or not based on platformVars
          function determinePlayAnimation() {
            // Desktop or iPad landscape orientation
            if ((platformVars.isDesktop && !platformVars.isMobile && !platformVars.isIpad && !isDropdown) || platformVars.orientation === false) {
              animation.play(0);
            }
          }

          if (animationPlaying) {
            return;
          }

          animationPlaying = true;

          determinePlayAnimation();
        });

      // Mobile / iPad Portrait event
      $sideNavContent.find('.nav_logo').on('click', function (e) {
        // Hides or shows the nav if browser is mobile, portrait display, or if dropdown is enabled
        function hideShowNav() {
          // Landscape
          if (platformVars.isMobile || platformVars.orientation || isDropdown) {
            // Prevent normal link behavior and play animation
            e.preventDefault();

            if ($sideNavContent.hasClass('active')) {
              animation.play('exit');
            } else {
              animation.play(0);
            }
          }
        }

        // Must be mobile or ipad portrait or a dropdown
        if (!platformVars.isMobile && !(platformVars.isIpad && platformVars.orientation) && !isDropdown) {
          return;
        }

        hideShowNav();
      });
      // END: Events
    }
  };
})(jQuery);
